import { GWidget } from "./GWidget";
import { RelationType } from "./Const";
import { UIConfig2 } from "./UIConfig";
import { Event } from "../events/Event";
import { Point } from "../maths/Point";
import { Loader } from "../net/Loader";
export class GWindow extends GWidget {
    constructor() {
        super();
        this._requestingCmd = 0;
        this.bringToFontOnClick = UIConfig2.bringWindowToFrontOnClick;
        this.on(Event.DISPLAY, this, this._onShown);
        this.on(Event.UNDISPLAY, this, this._onHidden);
        this.on(Event.MOUSE_DOWN, this, this._winTouchBegin);
    }
    get contentPane() {
        return this._contentPane;
    }
    set contentPane(value) {
        if (this._contentPane != value) {
            if (this._contentPane)
                this.removeChild(this._contentPane);
            this._contentPane = value;
            if (this._contentPane) {
                this.addChild(this._contentPane);
                this.size(this._contentPane.width, this._contentPane.height);
                this._contentPane.addRelation(this, RelationType.Size);
                this._frame = this._contentPane.getChild("frame");
                if (this._frame) {
                    this.closeButton = this._frame.getChild("closeButton");
                    this.dragArea = this._frame.getChild("dragArea");
                    this.contentArea = this._frame.getChild("contentArea");
                }
            }
        }
    }
    get frame() {
        return this._frame;
    }
    get closeButton() {
        return this._closeButton;
    }
    set closeButton(value) {
        if (this._closeButton)
            this._closeButton.off(Event.CLICK, this, this.closeEventHandler);
        this._closeButton = value;
        if (this._closeButton)
            this._closeButton.on(Event.CLICK, this, this.closeEventHandler);
    }
    get dragArea() {
        return this._dragArea;
    }
    set dragArea(value) {
        if (this._dragArea != value) {
            if (this._dragArea) {
                this._dragArea.draggable = false;
                this._dragArea.off(Event.DRAG_START, this, this._dragStart);
            }
            this._dragArea = value;
            if (this._dragArea) {
                this._dragArea.draggable = true;
                this._dragArea.on(Event.DRAG_START, this, this._dragStart);
            }
        }
    }
    get contentArea() {
        return this._contentArea;
    }
    set contentArea(value) {
        this._contentArea = value;
    }
    show() {
        GWidget._defaultRoot.showWindow(this);
    }
    hide() {
        if (this.isShowing)
            this.doHideAnimation();
    }
    hideImmediately() {
        GWidget._defaultRoot.hideWindowImmediately(this);
    }
    toggleStatus() {
        if (this.isTop)
            this.hide();
        else
            this.show();
    }
    get isShowing() {
        return this.parent != null;
    }
    get isTop() {
        return this.parent && this.parent.getChildIndex(this) == this.parent.numChildren - 1;
    }
    get modal() {
        return this._modal;
    }
    set modal(val) {
        this._modal = val;
    }
    bringToFront() {
        GWidget._defaultRoot.bringToFront(this);
    }
    showModalWait(requestingCmd) {
        if (requestingCmd != null)
            this._requestingCmd = requestingCmd;
        if (UIConfig2.windowModalWaiting) {
            if (!this._modalWaitPane)
                this._modalWaitPane = Loader.createNodes(UIConfig2.windowModalWaiting);
            this._modalWaitPane.mouseEnabled = true;
            this.layoutModalWaitPane();
            this.addChild(this._modalWaitPane);
        }
    }
    layoutModalWaitPane() {
        if (this._contentArea) {
            let pt = this._frame.localToGlobal(s_pt.setTo(0, 0));
            pt = this.globalToLocal(pt);
            this._modalWaitPane.pos(pt.x + this._contentArea.x, pt.y + this._contentArea.y);
            this._modalWaitPane.size(this._contentArea.width, this._contentArea.height);
        }
        else
            this._modalWaitPane.size(this.width, this.height);
    }
    closeModalWait(requestingCmd) {
        if (requestingCmd != null) {
            if (this._requestingCmd != requestingCmd)
                return false;
        }
        this._requestingCmd = 0;
        if (this.modalWaiting)
            this.removeChild(this._modalWaitPane);
        return true;
    }
    get modalWaiting() {
        return this._modalWaitPane != null && this._modalWaitPane.parent != null;
    }
    onInit() {
    }
    onShown() {
    }
    onHide() {
    }
    doShowAnimation() {
        this.onShown();
    }
    doHideAnimation() {
        this.hideImmediately();
    }
    destroy() {
        if (this.parent)
            this.hideImmediately();
        super.destroy();
    }
    closeEventHandler() {
        this.hide();
    }
    _onShown() {
        if (!this._inited) {
            if (!this._loading) {
                this._loading = true;
                Promise.resolve(this.onInit()).then(() => {
                    this._loading = false;
                    this._inited = true;
                    if (this.isShowing)
                        this.doShowAnimation();
                });
            }
        }
        else
            this.doShowAnimation();
    }
    _onHidden() {
        this.closeModalWait();
        this.onHide();
    }
    _winTouchBegin() {
        if (this.isShowing && this.bringToFontOnClick)
            this.bringToFront();
    }
    _dragStart() {
        this._dragArea.stopDrag();
        this.startDrag();
    }
}
const s_pt = new Point();
